export default __webpack_public_path__ + "static/media/class_xi_xii.82a8ed4b.png";